module.exports = "<p>\n  create works!\n</p>\n"